// Preset avatars with emoji representations organized by category
export const AVATAR_CATEGORIES = [
  { id: 'people', label: 'People', icon: '👤' },
  { id: 'animals', label: 'Animals', icon: '🐾' },
  { id: 'fantasy', label: 'Fantasy', icon: '✨' },
];

export const PRESET_AVATARS = [
  // People - Diverse human faces with skin tone variations
  // Default/Yellow tone
  { id: 'avatar_man_1', emoji: '👨', label: 'Man', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_1', emoji: '👩', label: 'Woman', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_1', emoji: '🧑', label: 'Person', color: '#8B5CF6', category: 'people' },
  
  // Light skin tone
  { id: 'avatar_man_light', emoji: '👨🏻', label: 'Man (Light)', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_light', emoji: '👩🏻', label: 'Woman (Light)', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_light', emoji: '🧑🏻', label: 'Person (Light)', color: '#8B5CF6', category: 'people' },
  
  // Medium-Light skin tone
  { id: 'avatar_man_medlight', emoji: '👨🏼', label: 'Man (Med-Light)', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_medlight', emoji: '👩🏼', label: 'Woman (Med-Light)', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_medlight', emoji: '🧑🏼', label: 'Person (Med-Light)', color: '#8B5CF6', category: 'people' },
  
  // Medium skin tone
  { id: 'avatar_man_medium', emoji: '👨🏽', label: 'Man (Medium)', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_medium', emoji: '👩🏽', label: 'Woman (Medium)', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_medium', emoji: '🧑🏽', label: 'Person (Medium)', color: '#8B5CF6', category: 'people' },
  
  // Medium-Dark skin tone
  { id: 'avatar_man_meddark', emoji: '👨🏾', label: 'Man (Med-Dark)', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_meddark', emoji: '👩🏾', label: 'Woman (Med-Dark)', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_meddark', emoji: '🧑🏾', label: 'Person (Med-Dark)', color: '#8B5CF6', category: 'people' },
  
  // Dark skin tone
  { id: 'avatar_man_dark', emoji: '👨🏿', label: 'Man (Dark)', color: '#3B82F6', category: 'people' },
  { id: 'avatar_woman_dark', emoji: '👩🏿', label: 'Woman (Dark)', color: '#EC4899', category: 'people' },
  { id: 'avatar_person_dark', emoji: '🧑🏿', label: 'Person (Dark)', color: '#8B5CF6', category: 'people' },
  
  // Bearded with skin tones
  { id: 'avatar_beard_light', emoji: '🧔🏻', label: 'Bearded (Light)', color: '#92400E', category: 'people' },
  { id: 'avatar_beard_medlight', emoji: '🧔🏼', label: 'Bearded (Med-Light)', color: '#92400E', category: 'people' },
  { id: 'avatar_beard_medium', emoji: '🧔🏽', label: 'Bearded (Medium)', color: '#92400E', category: 'people' },
  { id: 'avatar_beard_meddark', emoji: '🧔🏾', label: 'Bearded (Med-Dark)', color: '#92400E', category: 'people' },
  { id: 'avatar_beard_dark', emoji: '🧔🏿', label: 'Bearded (Dark)', color: '#92400E', category: 'people' },
  
  // Hair styles with skin tones
  { id: 'avatar_curly_light', emoji: '👩🏻‍🦱', label: 'Curly (Light)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_curly_medium', emoji: '👩🏽‍🦱', label: 'Curly (Medium)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_curly_dark', emoji: '👩🏿‍🦱', label: 'Curly (Dark)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_red_light', emoji: '👨🏻‍🦰', label: 'Red Hair (Light)', color: '#EF4444', category: 'people' },
  { id: 'avatar_red_medium', emoji: '👨🏽‍🦰', label: 'Red Hair (Medium)', color: '#EF4444', category: 'people' },
  { id: 'avatar_white_light', emoji: '👩🏻‍🦳', label: 'White Hair (Light)', color: '#6B7280', category: 'people' },
  { id: 'avatar_white_medium', emoji: '👩🏽‍🦳', label: 'White Hair (Medium)', color: '#6B7280', category: 'people' },
  { id: 'avatar_white_dark', emoji: '👩🏿‍🦳', label: 'White Hair (Dark)', color: '#6B7280', category: 'people' },
  { id: 'avatar_bald_light', emoji: '👨🏻‍🦲', label: 'Bald (Light)', color: '#F97316', category: 'people' },
  { id: 'avatar_bald_medium', emoji: '👨🏽‍🦲', label: 'Bald (Medium)', color: '#F97316', category: 'people' },
  { id: 'avatar_bald_dark', emoji: '👨🏿‍🦲', label: 'Bald (Dark)', color: '#F97316', category: 'people' },
  
  // Age variations with skin tones
  { id: 'avatar_older_man_light', emoji: '👴🏻', label: 'Older Man (Light)', color: '#78716C', category: 'people' },
  { id: 'avatar_older_man_medium', emoji: '👴🏽', label: 'Older Man (Medium)', color: '#78716C', category: 'people' },
  { id: 'avatar_older_man_dark', emoji: '👴🏿', label: 'Older Man (Dark)', color: '#78716C', category: 'people' },
  { id: 'avatar_older_woman_light', emoji: '👵🏻', label: 'Older Woman (Light)', color: '#A855F7', category: 'people' },
  { id: 'avatar_older_woman_medium', emoji: '👵🏽', label: 'Older Woman (Medium)', color: '#A855F7', category: 'people' },
  { id: 'avatar_older_woman_dark', emoji: '👵🏿', label: 'Older Woman (Dark)', color: '#A855F7', category: 'people' },
  { id: 'avatar_baby_light', emoji: '👶🏻', label: 'Baby (Light)', color: '#FBBF24', category: 'people' },
  { id: 'avatar_baby_medium', emoji: '👶🏽', label: 'Baby (Medium)', color: '#FBBF24', category: 'people' },
  { id: 'avatar_baby_dark', emoji: '👶🏿', label: 'Baby (Dark)', color: '#FBBF24', category: 'people' },
  { id: 'avatar_child_light', emoji: '🧒🏻', label: 'Child (Light)', color: '#22C55E', category: 'people' },
  { id: 'avatar_child_medium', emoji: '🧒🏽', label: 'Child (Medium)', color: '#22C55E', category: 'people' },
  { id: 'avatar_child_dark', emoji: '🧒🏿', label: 'Child (Dark)', color: '#22C55E', category: 'people' },
  
  // Professionals with skin tones
  { id: 'avatar_ninja', emoji: '🥷', label: 'Ninja', color: '#1F2937', category: 'people' },
  { id: 'avatar_astronaut_light', emoji: '👩🏻‍🚀', label: 'Astronaut (Light)', color: '#6366F1', category: 'people' },
  { id: 'avatar_astronaut_medium', emoji: '👩🏽‍🚀', label: 'Astronaut (Medium)', color: '#6366F1', category: 'people' },
  { id: 'avatar_astronaut_dark', emoji: '👩🏿‍🚀', label: 'Astronaut (Dark)', color: '#6366F1', category: 'people' },
  { id: 'avatar_artist_light', emoji: '🧑🏻‍🎨', label: 'Artist (Light)', color: '#EC4899', category: 'people' },
  { id: 'avatar_artist_medium', emoji: '🧑🏽‍🎨', label: 'Artist (Medium)', color: '#EC4899', category: 'people' },
  { id: 'avatar_artist_dark', emoji: '🧑🏿‍🎨', label: 'Artist (Dark)', color: '#EC4899', category: 'people' },
  { id: 'avatar_tech_light', emoji: '🧑🏻‍💻', label: 'Technologist (Light)', color: '#10B981', category: 'people' },
  { id: 'avatar_tech_medium', emoji: '🧑🏽‍💻', label: 'Technologist (Medium)', color: '#10B981', category: 'people' },
  { id: 'avatar_tech_dark', emoji: '🧑🏿‍💻', label: 'Technologist (Dark)', color: '#10B981', category: 'people' },
  { id: 'avatar_scientist_light', emoji: '🧑🏻‍🔬', label: 'Scientist (Light)', color: '#14B8A6', category: 'people' },
  { id: 'avatar_scientist_medium', emoji: '🧑🏽‍🔬', label: 'Scientist (Medium)', color: '#14B8A6', category: 'people' },
  { id: 'avatar_scientist_dark', emoji: '🧑🏿‍🔬', label: 'Scientist (Dark)', color: '#14B8A6', category: 'people' },
  { id: 'avatar_cook_light', emoji: '🧑🏻‍🍳', label: 'Cook (Light)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_cook_medium', emoji: '🧑🏽‍🍳', label: 'Cook (Medium)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_cook_dark', emoji: '🧑🏿‍🍳', label: 'Cook (Dark)', color: '#F59E0B', category: 'people' },
  { id: 'avatar_student_light', emoji: '🧑🏻‍🎓', label: 'Graduate (Light)', color: '#8B5CF6', category: 'people' },
  { id: 'avatar_student_medium', emoji: '🧑🏽‍🎓', label: 'Graduate (Medium)', color: '#8B5CF6', category: 'people' },
  { id: 'avatar_student_dark', emoji: '🧑🏿‍🎓', label: 'Graduate (Dark)', color: '#8B5CF6', category: 'people' },
  
  // Animals
  { id: 'avatar_cat', emoji: '🐱', label: 'Cat', color: '#F59E0B', category: 'animals' },
  { id: 'avatar_dog', emoji: '🐕', label: 'Dog', color: '#8B5CF6', category: 'animals' },
  { id: 'avatar_bird', emoji: '🐦', label: 'Bird', color: '#3B82F6', category: 'animals' },
  { id: 'avatar_fox', emoji: '🦊', label: 'Fox', color: '#F97316', category: 'animals' },
  { id: 'avatar_panda', emoji: '🐼', label: 'Panda', color: '#6B7280', category: 'animals' },
  { id: 'avatar_lion', emoji: '🦁', label: 'Lion', color: '#EAB308', category: 'animals' },
  { id: 'avatar_tiger', emoji: '🐯', label: 'Tiger', color: '#F97316', category: 'animals' },
  { id: 'avatar_bear', emoji: '🐻', label: 'Bear', color: '#92400E', category: 'animals' },
  { id: 'avatar_rabbit', emoji: '🐰', label: 'Rabbit', color: '#EC4899', category: 'animals' },
  { id: 'avatar_koala', emoji: '🐨', label: 'Koala', color: '#6B7280', category: 'animals' },
  { id: 'avatar_penguin', emoji: '🐧', label: 'Penguin', color: '#1F2937', category: 'animals' },
  { id: 'avatar_owl', emoji: '🦉', label: 'Owl', color: '#78350F', category: 'animals' },
  { id: 'avatar_wolf', emoji: '🐺', label: 'Wolf', color: '#4B5563', category: 'animals' },
  { id: 'avatar_unicorn', emoji: '🦄', label: 'Unicorn', color: '#D946EF', category: 'animals' },
  { id: 'avatar_butterfly', emoji: '🦋', label: 'Butterfly', color: '#06B6D4', category: 'animals' },
  
  // Fantasy & Fun
  { id: 'avatar_dragon', emoji: '🐲', label: 'Dragon', color: '#059669', category: 'fantasy' },
  { id: 'avatar_alien', emoji: '👽', label: 'Alien', color: '#22C55E', category: 'fantasy' },
  { id: 'avatar_robot', emoji: '🤖', label: 'Robot', color: '#6B7280', category: 'fantasy' },
  { id: 'avatar_ghost', emoji: '👻', label: 'Ghost', color: '#E5E7EB', category: 'fantasy' },
  { id: 'avatar_vampire', emoji: '🧛', label: 'Vampire', color: '#7C3AED', category: 'fantasy' },
  { id: 'avatar_zombie', emoji: '🧟', label: 'Zombie', color: '#84CC16', category: 'fantasy' },
  { id: 'avatar_mage', emoji: '🧙', label: 'Mage', color: '#8B5CF6', category: 'fantasy' },
  { id: 'avatar_fairy', emoji: '🧚', label: 'Fairy', color: '#F472B6', category: 'fantasy' },
  { id: 'avatar_elf', emoji: '🧝', label: 'Elf', color: '#10B981', category: 'fantasy' },
  { id: 'avatar_superhero', emoji: '🦸', label: 'Superhero', color: '#EF4444', category: 'fantasy' },
  { id: 'avatar_supervillain', emoji: '🦹', label: 'Supervillain', color: '#7C3AED', category: 'fantasy' },
  { id: 'avatar_genie', emoji: '🧞', label: 'Genie', color: '#0EA5E9', category: 'fantasy' },
];

// Get avatar by ID
export const getAvatarById = (id) => {
  return PRESET_AVATARS.find(a => a.id === id) || PRESET_AVATARS[0];
};

// Days of week for scheduling
export const DAYS_OF_WEEK = [
  { short: 'Mon', full: 'Monday' },
  { short: 'Tue', full: 'Tuesday' },
  { short: 'Wed', full: 'Wednesday' },
  { short: 'Thu', full: 'Thursday' },
  { short: 'Fri', full: 'Friday' },
  { short: 'Sat', full: 'Saturday' },
  { short: 'Sun', full: 'Sunday' },
];
